// 丹麦语

export default{
    shipping_method: 'Leveringsmetode',
    shipping_time: 'Leveringstid',
    costs: 'Omkostninger',
    shipping_to: 'Levering til'
}


// WEBPACK FOOTER //
// ./src/i18n/da.js